import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionGuides/pageContext';

export const PetitionGuidesErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Petition Guides page (error: ${error})`);
};
